module.exports = __webpack_public_path__ + "img/alekseev.01a5ad59.jpg";